import "%modules%/header/header";
import "%modules%/footer/footer";
import "%modules%/map/map";
import "%modules%/depaty-card/depaty-card"